<template>
	<div>
		<h1>{{ viewver.name }}</h1>

		<span>Filtre</span>
		<b-form-select v-model="filter" :options="filters"></b-form-select>

		<p>
			{{ nb + 1 }}/{{ count_lines }} lignes
			<b-button variant="link" v-show="nb > 0" @click="setOffset(nb - 1)"
				>Précédent</b-button
			><b-button
				variant="link"
				v-show="nb + 1 < count_lines"
				@click="setOffset(nb + 1)"
				>Suivant</b-button
			>
		</p>

		<div v-show="count_lines > 0">
			<span>{{ result[viewver.column_name] }} (id {{ result.id }})</span
			><br /><br />
			<viewXml :project="project" ref="view_xml"></viewXml>
		</div>
	</div>
</template>

<script>
	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import users from "../services/users.js";
	import projects from "../services/projects.js";
	import database from "../services/database.js";
	import viewXml from "../components/viewXml.vue";

	export default {
		name: "viewver",
		components: {
			viewXml,
		},
		watch: {
			filter: {
				async handler() {
					this.nb = 0;
					await this.count();

					if (this.count_lines > 0) await this.select();
				},
			},
		},
		data() {
			return {
				viewver: {},
				filters: [],
				filter: "",
				count_lines: 0,
				nb: 0,
				result: {},
				project: {},
			};
		},
		methods: {
			async setOffset(nb) {
				var diff = await this.count();

				if (!diff) this.nb = nb;

				if (this.nb >= this.count_lines && this.nb > 0)
					this.nb = this.count_lines - 1;
				if (this.count_lines > 0) await this.select();
			},
			async setFilters() {
				var result = await database.get("SELECT", this.viewver.db, {
					select: "DISTINCT " + this.viewver.filter + " AS filter",
				});

				console.log(result);

				this.filters = [];
				for (var i = 0; i < result.length; i++) {
					this.filters.push(result[i].filter);
				}
			},
			async count() {
				var result = await database.get("SELECT", this.viewver.db, {
					select: "count(*) AS count",
					end: this.viewver.filter + " = '" + this.filter + "'",
				});
				if (this.count_lines != result[0].count) {
					this.count_lines = result[0].count;
					return true;
				} else {
					this.count_lines = result[0].count;
					return false;
				}
				console.log(result);
			},
			async select() {
				var result = await database.get("SELECT", this.viewver.db, {
					end:
						this.viewver.filter +
						" = '" +
						this.filter +
						"' order by id desc limit 1 offset " +
						this.nb,
				});
				this.result = result[0];

				console.log(result);
				this.$refs.view_xml.viewFile(
					this.result[this.viewver.column_url],
					this.result[this.viewver.column_name],
					{ origin: this.result[this.viewver.column_pdf] }
				);
			},
		},
		created: async function () {
			var self = this;

			let response = await users.getSelf(true);
			this.client = response.client;

			for (var i = 0; i < this.client.details.viewver.length; i++) {
				if (
					this.client.details.viewver[i].name ==
					this.$route.params.name
				)
					this.viewver = this.client.details.viewver[i];
			}

			await this.setFilters();

			this.filter = this.viewver.default_filter;
			this.project = await projects.get(this.viewver.project_uid);
		},
	};
</script>

<style></style>
